import React from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch
} from "react-router-dom";

import MetaStateCheck from "./modules/common/MetaStateCheck";
import PitchAnimation from "./modules/PitchAnimation/pages/PitchAnimation";
import LiveConferenceContainer from "./modules/InfoScreens/containers/LiveConferenceContainer";
import ErrorBoundaries from "./modules/common/ErrorReporting/ErrorBoundaries";
import ScaleWrapper from "./modules/common/ScaleWrapper";

import "./modules/common/ErrorReporting/ErrorPage.scss";
import MatchTickerContainer from "./modules/InfoScreens/containers/MatchTickerContainer";
import Container from "./modules/InfoTerminal/container";
import InfoTerminal from "./modules/InfoTerminal/pages/InfoTerminal";

const App = () => {
  return (
    <ErrorBoundaries errorHandler="page">
      <MetaStateCheck>
        <Router>
          <Switch>
            <Route path="/" exact render={() => <ScaleWrapper><PitchAnimation /></ScaleWrapper>} />
            <Route path="/match-ticker" exact render={() => <ScaleWrapper><MatchTickerContainer errorResetKey={0} /></ScaleWrapper>} />
            <Route
              path="/live-conference"
              exact
              render={(props) => <ScaleWrapper><LiveConferenceContainer {...props as any} errorResetKey={0} /></ScaleWrapper>}
            />
            <Route path="/league/:id" render={(props) => <ScaleWrapper><LiveConferenceContainer {...props as any} errorResetKey={0} /></ScaleWrapper>} />
            <Route path="/info-terminal-screen-saver" exact component={InfoTerminal} />
            <Route path="/info-terminal" exact component={InfoTerminal} />
            <Route path="/info-terminal/betslip/:betslipId" component={Container} />
            <Route path="/info-terminal/customer-card/:ccId" component={Container} />
            <Redirect to="/" />
          </Switch>
          <div className="report__preload" />
        </Router>
      </MetaStateCheck>
    </ErrorBoundaries>
  );
};

export default App;
